import { connect } from 'react-redux';
import DashboardPanelCompany from '../../components/DashboardPanelCompany';

import {
  fetchAllEventsForCompanyDispatch,
  setCurrentBranchesRecordDispatch,
  openEditEventPanelDispatch,
  eventEditClickDispatch,
  fetchAllCourseRecordsForCompanyDispatch,
  fetchAllCoursesForCompanyDispatch,
  fetchAllAccidentsForCompanyDispatch,
  openEditCoursePanelDispatch,
  courseEditClickDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    companyId: state.users.user.item.companyId,
    events: state.events.eventsByCompany.items,
    courses: state.courses.coursesByCompany.items,
    accidents: state.accidents.accidentsByCompany.items,
    courseRecords: state.courses.courseRecordsByCompany.items
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchAllEventsForCompany: (companyId) => {
      dispatch(fetchAllEventsForCompanyDispatch(companyId));
    },
    fetchAllCourseRecordsForCompany: (companyId) => {
      dispatch(fetchAllCourseRecordsForCompanyDispatch(companyId));
    },
    fetchAllCoursesForCompany: (companyId) => {
      dispatch(fetchAllCoursesForCompanyDispatch(companyId));
    },
    fetchAllAccidentsForCompany: (companyId) => {
      dispatch(fetchAllAccidentsForCompanyDispatch(companyId));
    },
    setCurrentBranchesRecord: (recordType) => {
      dispatch(setCurrentBranchesRecordDispatch(recordType));
    },
    handleEventRecordEditClick: (event) => {
      dispatch(openEditEventPanelDispatch(true));
      dispatch(eventEditClickDispatch(event));
    },
    handleCourseRecordEditClick: (course) => {
      dispatch(openEditCoursePanelDispatch(true));
      dispatch(courseEditClickDispatch(course));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardPanelCompany);
